import type { HourlyPreparationTime } from "../../../../graphql/types"

export const createEmptyHourlyPreparationTime = (hour: number, index: number): HourlyPreparationTime => ({
    index: index,
    hour: hour,
    itemNames: [],
    count: 0,
})
